import { render, staticRenderFns } from "./AuditsEmpty.vue?vue&type=template&id=97a36a40&scoped=true&"
import script from "./AuditsEmpty.vue?vue&type=script&lang=ts&"
export * from "./AuditsEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a36a40",
  null
  
)

export default component.exports